import ApexCharts from 'apexcharts'

export default class Chart {
    constructor(element) {
        let options = JSON.parse(element.dataset.chart)

        if (element.dataset.transformer) {
            window[element.dataset.transformer](options)
        }

        options.chart = options.chart ?? {}
        options.chart.animations = options.chart.animations ?? {}
        options.chart.animations.enabled = false

        const chart = new ApexCharts(element, options)
        chart.render()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new Chart(element))
    }
}
